import styled from 'styled-components';

export const IssueBox = styled.div`
  padding: 1rem;
  box-sizing: border-box;
  color: #2a3030;
  text-align: left;

  div.error {
    font-size: 1.3rem;
    color: #c2392c;
    padding: 0.3rem;
    margin-bottom: 1rem;
    display: flex;
    align-items: center;

    svg {
      margin-right: 1rem;
      width: 2rem;
      height: auto;
    }
  }

  &.rate {
    width: 85vw;
    max-width: 350px;

    textarea {
      resize: none;
      min-height: 4rem;
      padding: 0;
      width: calc(100% - 15px);
      color: #2a3030;
      overflow-y: hidden;
    }
  }

  .issue-message {
    width: 100%;
  }

  span.text-area {
    width: calc(100% - 15px);
    font-size: 1.6rem;
    color: #2a3030;
  }

  .tooltip-info {
    font-size: 2rem;
    font-weight: 700;
    font-style: italic;
    margin-bottom: 1rem;
  }

  .input-group {
    position: relative;

    .error {
      color: #b96082;
      position: absolute;
      bottom: -10px;
      width: 100%;
      left: 3px;
      font-weight: 500;
      font-size: 10px;
    }
  }

  input,
  textarea {
    border: none;
    outline: none;
    font-family: 'Ubuntu', sans-serif;
    font-size: 1.6rem;
  }

  button {
    border-radius: 6px;
    padding: 1.3rem 2rem;
    font-size: 1.6rem;
    font-weight: 700;
    text-transform: uppercase;
    transition: box-shadow 0.42s cubic-bezier(0.165, 0.84, 0.44, 1);
    border: none;
    text-decoration: none;
    margin-right: 1rem;

    &:last-of-type {
      margin-right: 0;
    }

    &:hover {
      cursor: pointer;
    }

    &:focus {
      outline: none;
    }

    &:disabled {
      cursor: not-allowed;
      box-shadow: inset 0 0 0 1px #2a3030;
      background-color: #e1e4e4;
    }

    &.primary {
      background-color: #fbb600;
      color: #2a3030;

      &:hover {
        box-shadow: inset 0 0 0 3px #2a3030;
      }
    }

    &.secondary {
      background-color: #fff;
      color: #2a3030;
      box-shadow: inset 0 0 0 2px #fbb600;

      &:hover {
        box-shadow: inset 0 0 0 3px #2a3030;
      }
    }
  }

  .actions {
    margin-top: 2rem;
  }

  @media (min-width: 768px) {
    padding: 3rem;

    &.rate {
      width: 400px;
      max-width: 400px;
    }
  }
`;
